import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  InventoryHistorySearchRequest,
  InventoryHistoryJobResponse,
  InventoryHistoryJobResult,
} from '../../models/inventory/inventory-history.model';

export interface InventoryRequestModel {
  skuId?: number;
  refId?: string;
  accounts: string[];
}

export interface FranchiseResultModel {
  name: string;
  description: string;
}

export interface VtexInventoryByFranchiseItemResponse {
  warehouseId: string;
  warehouseName: string;
  totalQuantity: number;
  reservedQuantity: number;
  hasUnlimitedQuantity: boolean;
  timeToRefill: string;
  dateOfSupplyUtc: string;
  leadTime: string;
}

export interface VtexInventoryByFranchiseResponse {
  id: string;
  name: string;
  items: VtexInventoryByFranchiseItemResponse[];
}

@Injectable({ providedIn: 'root' })
export class InventoryService {
  private readonly baseUrl = `${environment.backend.url}/api/vtex`;

  constructor(private readonly http: HttpClient) {}

  listFranchises(): Observable<FranchiseResultModel[]> {
    return this.http.get<FranchiseResultModel[]>(`${this.baseUrl}/franchise/v1/list`);
  }

  getInventory(req: InventoryRequestModel): Observable<VtexInventoryByFranchiseResponse[]> {
    let params = new HttpParams();
    if (req.skuId) params = params.append('skuId', req.skuId.toString());
    if (req.refId) params = params.append('refId', req.refId);
    if (req.accounts && req.accounts.length) {
      for (const account of req.accounts) {
        params = params.append('accounts', account);
      }
    }
    return this.http.get<VtexInventoryByFranchiseResponse[]>(`${this.baseUrl}/logistics/v1/inventory`, { params });
  }

  searchHistory(req: InventoryHistorySearchRequest): Observable<InventoryHistoryJobResponse> {
    return this.http.post<InventoryHistoryJobResponse>(
      `${this.baseUrl}/logistics/inventory/v1/history`,
      req
    );
  }

  getHistoryResult(jobId: string): Observable<InventoryHistoryJobResult> {
    return this.http.get<InventoryHistoryJobResult>(
      `${this.baseUrl}/logistics/inventory/v1/history/${jobId}`
    );
  }
}
